module.exports = __webpack_public_path__ + "97eb0d330dfda97a4d73d1ab9d81ccf0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-chef-s.png
// module id = 2716
// module chunks = 0